export default __webpack_public_path__ + "static/media/logo.b9964af6.svg";